export const apiUrlConfig = {
  // INTERNAL API URLS
  BASE_BACKEND_URL: process.env.REACT_APP_API_URL,
  EXPRESS_BACKEND_V1: process.env.REACT_APP_ACTION_PLAN_API_URL,
  EXPRESS_BACKEND_V2: process.env.REACT_APP_API_URL_V2,

  // EXTERNAL API URLS
  IP_INFO_URL: 'https://ipinfo.io/json',
};
